export default __webpack_public_path__ + "static/suche-48376378200f159e9ae1fa2cdbd25957.svg";